// Responsive width of the admission drawer panel. Modals opened from inside the drawer reuse this
// (via ADMISSION_DRAWER_SURFACE_CLASSNAME) so they render contained within the drawer instead of
// over the whole viewport — keep both in sync with the Drawer's own className.
export const ADMISSION_DRAWER_WIDTH_CLASSES =
  'max-sm:w-full sm:w-[511px] md:w-[516px] lg:w-[592px] xl:w-[708px] 2xl:w-[883px]';

// `surfaceClassName` for ModalV2/ConfirmModalV2: constrains the modal (backdrop + centering box) to
// the drawer's box instead of `inset-0`, so it renders contained within the drawer.
export const ADMISSION_DRAWER_SURFACE_CLASSNAME = `inset-y-0 right-0 ${ADMISSION_DRAWER_WIDTH_CLASSES}`;

// z-index for modals opened from inside the drawer — must outrank the Drawer's own z-50 panel.
export const ADMISSION_DRAWER_OVERLAY_Z_INDEX = 60;
